export interface ToolRef {
  slug: string;
  customUrl?: string;
}

/**
 * Canonical href for a tool: customUrl tools (e.g. the math studio at
 * /math-question-generator) render their real UI at a top-level route —
 * /tools/[slug] for them only issues a redirect (src/proxy.ts).
 */
export function toolHref(tool: ToolRef): string {
  return tool.customUrl ?? `/tools/${tool.slug}`;
}
